module.exports = __webpack_public_path__ + "assets/img/logo_02.5b9eef2d.png";